import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./TemplateFooter2.module.css";
import { FaPhone, FaEnvelope, FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import { useAuth } from "../../Common/Configurations/AuthContext";

const TemplateFooter2 = ({
  branding,
  footerData,
  headerMenu = [],
  onNavigate,
  mode,
  templateId
}) => {

  const { user } = useAuth();
  const navigate = useNavigate();

  const brandName =
    branding?.brandName ||
    user?.brandName ||
    "Travel Agency";

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const aboutText =
    footerData?.aboutText ||
    "Explore the world with our premium travel experiences.";

  const handleNavClick = (e, item) => {
    const viewName = item.path === "/" ? "home" : item.path.replace("/", "");

    if (mode === "builder") {
      e.preventDefault();
      onNavigate({ name: viewName, params: null });
    }
    else if (mode === "preview") {
      e.preventDefault();
      navigate(`/template-preview/${templateId}/${viewName}`);
    }
  };

  return (
    <footer className={styles.footer}>

      <div className={styles.container}>

        <div className={styles.grid}>

          {/* Column 1 */}
          <div className={styles.column}>
            <h3 className={styles.brand}>{brandName}</h3>
            <p className={styles.text}>{aboutText}</p>

            <div className={styles.socials}>
              <a href="#"><FaFacebookF/></a>
              <a href="#"><FaInstagram/></a>
              <a href="#"><FaTwitter/></a>
            </div>
          </div>

          {/* Column 2 */}
          <div className={styles.column}>
            <h4 className={styles.heading}>Quick Links</h4>

            <ul className={styles.links}>
              {headerMenu.map(item => (
                <li key={item.id}>
                  <Link
                    to={item.path}
                    onClick={(e) => handleNavClick(e,item)}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 */}
          <div className={styles.column}>
            <h4 className={styles.heading}>Contact</h4>

            <div className={styles.contact}>
              <FaPhone/>
              <span>{phone}</span>
            </div>

            <div className={styles.contact}>
              <FaEnvelope/>
              <span>{email}</span>
            </div>
          </div>

          {/* Column 4 */}
          <div className={styles.column}>
            <h4 className={styles.heading}>Newsletter</h4>

            <p className={styles.text}>
              Subscribe for latest travel deals.
            </p>

            <input
              className={styles.input}
              placeholder="Enter email"
            />

            <button className={styles.subscribe}>
              Subscribe
            </button>
          </div>

        </div>

        <div className={styles.bottom}>
          © {new Date().getFullYear()} {brandName}. All Rights Reserved.
        </div>

      </div>

    </footer>
  );
};

export default TemplateFooter2;